/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnforcementCategoryEnum = 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE';

export const EnforcementCategoryEnum = {

    NON_SUBSCRIPTION: 'NON_SUBSCRIPTION' as EnforcementCategoryEnum,

    OVERAGE: 'OVERAGE' as EnforcementCategoryEnum,

    NONE: 'NONE' as EnforcementCategoryEnum
};

